import { defineComponent as _defineComponent } from 'vue'
import { onMounted, Ref, ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import CourseUnit from "@/interfaces/course-unit.interface";
import CourseWork from "@/interfaces/courseWork.interface";
import { useShowSuccessMessage } from "@/composables/use-notifications";


export default /*#__PURE__*/_defineComponent({
  __name: 'available-courseworks-component',
  setup(__props) {

const isFetching = ref(true);
const isError = ref(false);
// const fetchingCourseWorkId = ref(null);
const courseWorks: Ref<
  {
    course_unit: CourseUnit;
    course_work: CourseWork;
  }[]
> = ref([]);

const forMarksOnly = (courseWork: CourseWork) => {
  const submission = courseWork.student_course_work_submissions?.[0];
  return !!submission && submission.for_marks_only;
};

const isMissedCourseWork = (courseWork: CourseWork) => {
  const submission = courseWork.student_course_work_submissions?.[0];
  return courseWork.is_course_work_ended && !submission;
};

const isCourseWorkSubmitted = (courseWork: CourseWork) => {
  const submission = courseWork.student_course_work_submissions?.[0];
  return !!submission && submission.submitted_at;
};

const neverCompleted = (courseWork: CourseWork) => {
  const submission = courseWork.student_course_work_submissions?.[0];
  return !!submission && !submission.submitted_at;
};

const fetchAvailableCourseWork = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    course_works: {
      course_unit: CourseUnit;
      course_work: CourseWork;
    }[];
  }>({
    method: "GET",
    url: "course-work/fetch-all-for-student",
    loadingProperty: isFetching,
    errorLoadingProperty: isError,
    showSuccessMessage: false,
  });

  if (!request) return;
  if (request.success && request.message == "STUDENT COURSE WORKS RETRIEVED") {
    courseWorks.value = request.course_works;
  }
};

const getBackgroundColorClass = (course_work: CourseWork) => {
  //Check if student has submission
  const hasSubmission = !!course_work.student_course_work_submissions[0];
  if (!hasSubmission) return "bg-poor";

  const submission = course_work.student_course_work_submissions[0];

  //Check if the student submission has a score_group
  const scoreGroup = submission.score_group;
  if (!scoreGroup) return "bg-poor";

  if (scoreGroup === "EXCELLENT") {
    return "bg-excellent";
  } else if (scoreGroup === "FAIR") {
    return "bg-fair";
  }

  return "bg-poor";
};

const getStudentScore = (course_work: CourseWork) => {
  //Check if student has submission
  const hasSubmission = !!course_work.student_course_work_submissions[0];
  if (!hasSubmission) return "?";

  const submission = course_work.student_course_work_submissions[0];

  //Check if the student submission has a total_score
  const hasScore =
    submission.total_score !== null && submission.total_score !== undefined;
  if (!hasScore) return "?";

  return submission.total_score;
};

const downloadStudentCourseWorkResults = async (
  student_course_work_submission_id: string
) => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    link: string;
  }>({
    method: "GET",
    url: `course-work/online-marking/course-work-results/download/${student_course_work_submission_id}`,
    showFullScreenLoader: true,
    loadingProperty: null,
    showSuccessMessage: false,
  });

  if (!request) return;
  if (request.success && request.message == "REPORT GENERATED SUCCESSFULLY") {
    useShowSuccessMessage(
      "Processing Download",
      "Download in Progress. Please wait..."
    );
    const reportDownloadLink = request.link;
    const link = document.createElement("a");
    link.href = reportDownloadLink;
    link.click();
  }
};

onMounted(() => {
  fetchAvailableCourseWork();
});

return { __sfc: true,isFetching, isError, courseWorks, forMarksOnly, isMissedCourseWork, isCourseWorkSubmitted, neverCompleted, fetchAvailableCourseWork, getBackgroundColorClass, getStudentScore, downloadStudentCourseWorkResults }
}

})